import { render, staticRenderFns } from "./resumeEducation.vue?vue&type=template&id=18e8c92e&scoped=true&"
import script from "./resumeEducation.vue?vue&type=script&lang=js&"
export * from "./resumeEducation.vue?vue&type=script&lang=js&"
import style0 from "./resumeEducation.vue?vue&type=style&index=0&id=18e8c92e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e8c92e",
  null
  
)

export default component.exports